/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_FSM_CONNECTION_LIST
 */
export const listFsmPlatformsResponseItem = zod.object({
  "platform": zod.enum(['ColdStandard', 'HousecallPro', 'PoolBrain', 'ServiceTitan', 'Skimmer']),
  "status": zod.enum(['ComingSoon', 'GenerallyAvailable', 'Private'])
})
export const listFsmPlatformsResponse = zod.array(listFsmPlatformsResponseItem)

